module.exports = __webpack_public_path__ + "images/no_signal.61e9c7eb6fc17b444988e20c212af779.png";